import React, { createContext } from "react";

export interface IAdminContextProps {
    isAdmin: boolean;
    hasAdminPrivileges: boolean;
    hasStatsPrivileges: boolean;
    hasBasicPrivileges: boolean;
    currentUser: any;
}

export const SettingsContext = createContext < IAdminContextProps > ({} as IAdminContextProps);
